__turbopack_context__.v({
  "container": "MUOPYq_container",
  "inverse": "MUOPYq_inverse",
});
